export const stockTypeMapList = [
  {
    'typeName':'酒店',
    'state':0,
    'imageUrl': 'https://plan-export-icon.oss-cn-beijing.aliyuncs.com/%E5%9B%BD%E5%86%85%E9%85%92%E5%BA%97.png',
    'typeNameSimple':'住',
  },
  {
    'typeName':'会议',
    'state':1,
    'imageUrl': 'https://plan-export-icon.oss-cn-beijing.aliyuncs.com/%E4%BC%9A%E8%AE%AE%20%283%29.png',
    'typeNameSimple':'会',
  },
  {
    'typeName':'景点',
    'state':2,
    'imageUrl': 'https://plan-export-icon.oss-cn-beijing.aliyuncs.com/%E7%83%AD%E9%97%A8%E6%99%AF%E7%82%B9.png',
    'typeNameSimple':'景',
  },
  {
    'typeName':'用餐',
    'state':4,
    'imageUrl': 'https://plan-export-icon.oss-cn-beijing.aliyuncs.com/%E7%94%A8%E9%A4%90%E5%B0%B1%E9%A4%90.png',
    'typeNameSimple':'餐',
  }
]

export const stockTypeList=[{
  'typeName':'酒店',
  'state':0,
  'imageUrl': 'https://plan-export-icon.oss-cn-beijing.aliyuncs.com/%E5%9B%BD%E5%86%85%E9%85%92%E5%BA%97.png',
  'typeNameSimple':'住',
},{
  'typeName':'会议',
  'state':1,
  'imageUrl': 'https://plan-export-icon.oss-cn-beijing.aliyuncs.com/%E4%BC%9A%E8%AE%AE%20%283%29.png',
  'typeNameSimple':'会',
},{
  'typeName':'景点',
  'state':2,
  'imageUrl': 'https://plan-export-icon.oss-cn-beijing.aliyuncs.com/%E7%83%AD%E9%97%A8%E6%99%AF%E7%82%B9.png',
  'typeNameSimple':'景',
},{
  'typeName':'用车',
  'state':3,
  'imageUrl': 'https://plan-export-icon.oss-cn-beijing.aliyuncs.com/%E5%87%BA%E7%A7%9F.png',
  'typeNameSimple':'车',
},{
  'typeName':'用餐',
  'state':4,
  'imageUrl': 'https://plan-export-icon.oss-cn-beijing.aliyuncs.com/%E7%94%A8%E9%A4%90%E5%B0%B1%E9%A4%90.png',
  'typeNameSimple':'餐',
},{
  'typeName':'导游',
  'state':5,
  'imageUrl': 'https://plan-export-icon.oss-cn-beijing.aliyuncs.com/%E5%AF%BC%E6%B8%B8.png',
  'typeNameSimple':'导',
},{
  'typeName':'签证',
  'state':6,
  'typeNameSimple':'签',
},{
  'typeName':'商务',
  'state':7,
  'typeNameSimple':'商',
},{
  'typeName':'特色',
  'state':8,
  'typeNameSimple':'特',
},{
  'typeName':'公务',
  'state':10,
  'typeNameSimple':'公',
},{
  'typeName':'服务费',
  'state':12,
  'typeNameSimple':'服',
},{
  'typeName':'税费',
  'state':13,
  'typeNameSimple':'税',
},{
  'typeName':'其他',
  'state':14,
  'typeNameSimple':'其',
},{
  'typeName':'大交通',
  'state':15,
  'typeNameSimple':'交',
}]
export const stockTypeMap={
  "0":{
    'typeName':'酒店',
    'typeNameEn':'hotel',
    'typeNameSimple':'酒',
  },
  "1":{
    'typeName':'会议',
    'typeNameEn':'site',
    'typeNameSimple':'会',
  },
  "2":{
    'typeName':'景点',
    'typeNameEn':'spot',
    'typeNameSimple':'景',
    'priceCompany':'张',
    'useTime':'次',
  },
  "3":{
    'typeName':'用车',
    'typeNameEn':'traffic',
    'typeNameSimple':'车',
    'priceCompany':'辆',
    'useTime':'天',
  },
  "4":{
    'typeName':'用餐',
    'typeNameEn':'restaurant',
    'typeNameSimple':'餐',
  },
  "5":{
    'typeName':'导游',
    'typeNameEn':'guide',
    'typeNameSimple':'导',
  },
  "6":{
    'typeName':'签证',
    'typeNameEn':'visa',
    'typeNameSimple':'签',
  },
  "7":{
    'typeName':'商务',
    'typeNameEn':'business',
    'typeNameSimple':'商',
  },
  "8":{
    'typeName':'特色',
    'typeNameEn':'charact',
    'typeNameSimple':'特',
  },
  "10":{
    'typeName':'公务',
    'typeNameEn':'officialInvitation',
    'typeNameSimple':'公',
  },
  "11":{
    'typeName':'文本',
    'typeNameEn':'text',
    'typeNameSimple':'文',
  },
  "12":{
    'typeName':'服务费',
    'typeNameEn':'service'
  },
  "13":{
    'typeName':'税费',
    'typeNameEn':'tax'
  },
  "14":{
    'typeName':'其他',
    'typeNameEn':'other',
    'typeNameSimple':'其',
  },
  "15":{
    'typeName':'大交通',
    'typeNameEn':'bigTraffic',
  }
}
